import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router';
import DepositBanner from '../../assets/images/home_page/banners/joining_bonus.webp';
import JoiningBonusMob from '../../assets/images/banners/joining_bonus_mob.webp';
import AffliateBanner from '../../assets/images/home_page/banners/affiliate.webp';
import AffliateMobilePng2xBanner from '../../assets/images/banners/affiliate_mob.webp';
import DepositIcon from '../../assets/images/icons/depositIcon.svg';
import WithdrawIcon from '../../assets/images/icons/withdrawIcon.svg';
import { Button } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';
import b2bcasino from '../../assets/images/home_page/banners/Casino1.webp';
import b2bcasinomob from '../../assets/images/home_page/banners/Casino.webp';
import b2bsports from '../../assets/images/home_page/banners/Sports1.webp';
import b2bsportsmob from '../../assets/images/home_page/banners/Sports.webp';

const webStaticBanners = [
  {
    title: 'Deposit now',
    src: isMobile ? JoiningBonusMob : DepositBanner,
    path: '/transaction/deposit',
  },
  {
    title: 'Affiliate',
    src: isMobile ? AffliateMobilePng2xBanner : AffliateBanner,
    path: '/affiliate_program',
  },
];

const B2BwebStaticBanners = [
  {
    title: 'Casino',
    src: isMobile ? b2bcasinomob : b2bcasino,
    path: '/casino?provider=ALL&category=live',
  },
  {
    title: 'Sports',
    src: isMobile ? b2bsportsmob : b2bsports,
    path: '/exchange_sports/inplay',
  },
];

type StateProps = {
  loggedIn: any;
  langData: any;
};
const App: React.FC<StateProps> = (props) => {
  const { loggedIn, langData } = props;
  const history = useHistory();
  const { domainConfig } = useSelector((state: RootState) => state.common);
  const bannersToShow = domainConfig.b2cEnabled
    ? webStaticBanners
    : B2BwebStaticBanners;
  return (
    <div className="banner-container mt-12">
      <div className="banner-cards">
        {loggedIn && domainConfig.payments && domainConfig.b2cEnabled && (
          <>
            <Button
              onClick={() => history.push('/transaction/deposit')}
              className="deposit-btn"
            >
              <img src={DepositIcon} />
              {langData?.['deposit']}
            </Button>
            <Button
              onClick={() => history.push('/transaction/withdraw')}
              className="withdraw-btn"
            >
              <img src={WithdrawIcon} />
              {langData?.['withdraw']}
            </Button>
          </>
        )}

        {bannersToShow.map((banner) => (
          <div className={'inplay-bg banner-card-div'} key={banner.title}>
            <div
              className="banner-image"
              onClick={() => {
                if (loggedIn) {
                  history.push(banner.path);
                } else {
                  history.push('/login');
                }
              }}
            >
              <img src={banner.src} alt={banner.title} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    langData: state.common.langData,
  };
};

export default connect(mapStateToProps, null)(App);
